import { gql, useMutation } from '@apollo/client';
import { Num, Obj } from '@livecontrol/core-utils';
import { useCallback, useState } from 'react';

const MUTATION = gql`
mutation CreateEventTicket($eventId: Float!) {
    createEventTicket(event_id: $eventId) {
        success
    }
}
`;

interface TData {
    createEventTicket?: {
        success?: boolean;
    };
}

interface TVariable {
    eventId: number;
}

type EventIdType = number | string;

export const useCreateTicket = (): [
    (eventId: EventIdType) => Promise<boolean | undefined>,
    { loading: boolean; error?: Error; success?: boolean }
] => {
    const [success, setSuccess] = useState<boolean>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error>();
    const [mutation] = useMutation<TData, TVariable>(MUTATION);

    return [
        useCallback(async (eventId: EventIdType) => {
            let success_ = false;

            setError(undefined);
            setSuccess(undefined);
            setLoading(true);

            try {
                const variables = {
                    eventId: Num.normalize(eventId)
                };

                if (!Obj.isHydrated(variables)){
                    throw new Error('Invalid arguments');
                }

                const response = await mutation({ variables });

                success_ = !!response.data?.createEventTicket?.success;
            } catch(error_: unknown) {
                setError(<Error>error_);
            }

            setSuccess(success_);
            setLoading(false);

            return success_;
    }, [mutation]),
    {
        loading,
        error,
        success
    }];
};
